import { Component, OnInit } from '@angular/core';

interface Solution {
    title: string;
    description: string;
    icon: string;
    link: string;
    image: string;
}

@Component({
    selector: 'app-solutions',
    templateUrl: './solutions.component.html',
    styleUrls: ['./solutions.component.scss']
})
export class SolutionsComponent implements OnInit {
    solutions: Solution[] = [
        {
            icon: 'school',
            title: 'Schools/Colleges',
            description: 'Digitization of classrooms with panels, LMS & digital content',
            link: '/solutions/schools',
            image: 'https://d3uop73ba1wtqg.cloudfront.net/uploads/cR17pvD3RWaiW6Q8zn5a7ez72lV6KkYFDz5eT5Cg.jpg'
        },

        {
            icon: 'book_2',
            title: 'Education Institutions',
            description: 'Smart teaching tools, panels & LMS',
            link: '/solutions/education-institutions',
            image: 'https://d3uop73ba1wtqg.cloudfront.net/uploads/hQ4qtK8Aod1gnUsqBJxUpQhkI9c0rdUVFS2P4pjX.jpg'
        },
        {
            icon: 'business',
            title: 'Corporates',
            description: 'Training, meeting, conference presentations & boardroom tools',
            link: '/solutions/corporates',
            image: 'https://d3uop73ba1wtqg.cloudfront.net/uploads/uCiEwMfegzKL7tMKXUM7PUsvMTLFTp6aVEr7P9GO.jpg'
        },
        {
            icon: 'account_balance',
            title: 'Government',
            description: 'ICT labs, digital classrooms & tender-ready solutions',
            link: '/solutions/government',
            image: 'https://d3uop73ba1wtqg.cloudfront.net/uploads/2lWXpIXh0HPsiBKapsukXtaN7MZfUcBn14Th3XaU.jpg'
        },
        {
            icon: 'handshake',
            title: 'Partners',
            description: 'High-margin EdTech partnership program',
            link: '/solutions/partners',
            image: 'https://d3uop73ba1wtqg.cloudfront.net/uploads/avKaskTCUOSnSRSArRMtB5ftW3W2oniDIMVQZNC5.jpg'
        }
    ];

    ngOnInit(): void { }
}
